/**
 * The caller's own workshops — /api/v2/me/workshops. Self-scoped: the API
 * always reads the caller's crew membership, so there is no user id to send.
 */
import type { TeacherWorkshopChip } from '../components/dashboards/teacher/teacherApi';
import { apiFetch } from '../lib/apiFetch';

import type { WorkshopLifecycle } from './workshops';

/** A workshop chip plus the inputs the check-in rule reads. */
export interface MyWorkshopDto extends TeacherWorkshopChip {
  lifecycle: WorkshopLifecycle;
  /** Local midnight on the workshop's day, as a UTC instant. */
  checkInOpensAt: string;
}

/** Dates are `YYYY-MM-DD`, both ends included. */
export async function fetchMyWorkshops(fromDate: string, toDate: string): Promise<MyWorkshopDto[]> {
  const qs = new URLSearchParams({ from: fromDate, to: toDate }).toString();
  const res = await apiFetch(`/api/v2/me/workshops?${qs}`);
  if (!res.ok) throw new Error(`Failed to load your workshops (HTTP ${res.status})`);
  const body = (await res.json()) as { workshops: MyWorkshopDto[] };
  return body.workshops;
}
